<template>
  <div class="side-bar-container">
    <div v-bind:class="getSideMenuClass" @click="sidebar = true">
      <img src="../assets/side-bar-button.svg" />
    </div>

    <transition name="side-bar">
      <div v-show="sidebar">
        <div class="popup-helper" @click="closeSideBar()"></div>

        <div class="side-bar-background"></div>

        <div class="side-bar">
          <div class="border">
            <div class="section-title-container side-bar-icons">
            <span class="uhive-logo">
              <a href="https://www.uhive.com/"> <img src="../assets/uhive-logo-side-bar.svg" /> </a>
            </span>
            <span class="close-side-menu-icon">
              <img
                @click="closeSideBar()"
                src="../assets/close-side-menu-black-x.svg"
              />
            </span>
          </div>

          <div>
            <hr />
          </div>
        </div>

          <div class="sections-container">
            <ul class="sections">
              <li>
                <a href="https://www.uhive.com/">Home</a>
              </li>

              <li class="list-element">
                <div class="section-title-container" @click="changeActiveTitle(0)">
                  <span class="section-title">Features</span>
                  <span class="arrow"><img src="../assets/side-bar-arrow.svg"/></span>
                </div>

                <transition name="sub-section-transition">
                  <ul class="sub-sections" v-show="activeTitle==0">
                    <li><a href="https://www.uhive.com/spaces">Uhive Spaces</a></li>
                    <li><a href="https://www.uhive.com/gamification">Gamification</a></li>
                    <li><a href="https://www.uhive.com/originals">Originals</a></li>
                    <li><a href="https://www.uhive.com/moderation">Decentralized Moderation</a></li>
                    <li><a href="https://www.uhive.com/chatgpt-message">ChatGPT Challenge</a></li>
                    <li><a href="https://www.uhive.com/oasis">The Oasis</a></li>
                  </ul>
                </transition>
              </li>

              <li class="list-element">
                <div class="section-title-container" @click="changeActiveTitle(1)">
                  <span class="section-title">Tokenomics</span>
                  <span class="arrow"><img src="../assets/side-bar-arrow.svg"/></span>
                </div>

                <transition name="sub-section-transition">
                  <ul class="sub-sections" v-show="activeTitle==1">
                    <li><a href="https://www.uhive.com/tokenomics">Unique Approach</a></li>
                    <li><a href="https://www.uhive.com/token-release">Token Distribution</a></li>
                    <li><a href="https://www.uhive.com/tokenomics#rewards-and-incentives">Rewards and Incentives</a></li>
                    <li><a href="https://www.uhive.com/tokenomics#token-staking">Staking</a></li>
                    <li><a href="https://www.uhive.com/exchange"> Crypto Exchanges</a></li>
                  </ul>
                </transition>
              </li>

              <li class="list-element">
                <span class="section-title"><a href="https://www.uhive.com/earnings">Earnings</a></span>
              </li>

              <li class="list-element">
                <span class="section-title"><a href="https://uhive.com/learn">Learn</a></span>
              </li>

              <li class="list-element">
                <div class="section-title-container" @click="changeActiveTitle(2)">
                  <span class="section-title">Store</span>
                  <span class="arrow"><img src="../assets/side-bar-arrow.svg"/></span>
                </div>

                <transition name="sub-section-transition">
                  <ul class="sub-sections" v-show="activeTitle==2">
                    <li><a href="https://uhive.com/buy-tokens">Buy Tokens</a></li>
                    <li><a href="https://market.uhive.com/">Marketplace</a></li>
                  </ul>
                </transition>
              </li>
            </ul>
          </div>

          <div class="button-container">
            <button class="signin-button">
              <a href="https://wac.uhive.com/web/login/">Sign in</a>
            </button>
          </div>

          <div class="button-container">
            <button class="download-button">
              <a :href="getLink()">Download Uhive</a>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>



<script>
export default {
  props: {
    showUHiveBanner: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    closeSideBar() {
      this.activeTitle = -1;
      this.sidebar = false;
    },
    getLink() {
      let ua = navigator.userAgent;
      let isAndroid = /(android)/i.test(ua);
      if (isAndroid) {
        let intent = `${window.location.host}${window.location.pathname}`;
        return `intent://${intent}#Intent;scheme=https;package=uhiveapp.uhive.com.uhive;S.browser_fallback_url=https%3A%2F%2Fplay.google.com/store/apps/details?id=uhiveapp.uhive.com.uhive;end`;
      } else if (
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      ) {
        return "https://apps.apple.com/us/app/uhive-social-network/id1441517158";
      } else {
        return "https://www.uhive.com/download";
      }
    },
    changeActiveTitle(activeTitle){
      if(this.activeTitle == -1){
        this.activeTitle = activeTitle;
      }
      else{
        var current_active_title = this.activeTitle;
        this.activeTitle = -1;
        if(current_active_title != activeTitle){
          this.activeTitle = activeTitle;
        }
      }
    }
  },
  computed: {
    getSideMenuClass() {
      return this.showUHiveBanner ? "side-menu-button-with-banner" : "side-menu-button";
    },
  },
  data() {
    return {
      activeTitle: -1,
      metaverse: false,
      economy: false,
      community: false,
      sidebar: false,
    };
  },
};
</script>


<style scoped>
.sections-container{
  height: fit-content;
}
.sub-sections {
  padding: 0.5rem;
  font-weight: 200;
  list-style-type: none;
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.sections {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  font-family: SFUIDisplay;
  font-size: 1.15rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: 0.1rem;
  color: #030303;
  gap: 2rem;
}

@supports (-webkit-touch-callout: none) and (not (translate: none)) {
    .sections li{
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
    .download-btn{
      width: fit-content;
    }
    .border{
      margin-bottom: 1rem;
    }

}
.side-bar {
  margin-bottom: 5rem;
  overflow: scroll;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;

  z-index: 1000;
  color: #030303;
  padding: 2rem 1.75rem 5rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  position: absolute;
  right: 0;
  width: 70%;
  height: 100%;
  background-color: white;
}
.side-bar::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

.side-bar a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  color: inherit;
}

.signin-button {
  color: white;
  font-weight: 500px;
  font-size: 1.15rem;
  letter-spacing: 0.025rem;
  width: 10rem;
  height: 2.5rem;
  border-radius: 25px;
  background-image: linear-gradient(to right, #813199 5%, #6352df 94%);
  line-height: 0;
  margin-top: 2rem;
}
.download-button {
  color: white;
  font-weight: 500;
  font-size: 1.1rem;
  letter-spacing: 0.025rem;
  width: 10rem;
  height: 2.5rem;
  border-radius: 25px;
  background-color: #2979fc;
  line-height: 0;
  margin-top: 1rem;
}

.button-container {
  width: 100%;
  text-align: center;
}

.list-element {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.section-title {
  flex: 1;
}

.uhive-logo {
  flex: 1;
}

.arrow {
}

.section-title-container {
  display: flex;
  flex-direction: row;
}

hr {
  border-top: 1px solid #cbc3c3;
}

.side-menu-button {
  position: absolute;
  z-index: 1;
  top: 1rem;
  right: 1rem;
  padding: 0;
  margin: 0;
}
.side-menu-button img {
  width: 2rem;
}
.side-menu-button-with-banner{
  position: absolute;
  z-index: 1;
  top: 9rem;
  right: 1rem;
  padding: 0;
  margin: 0;
}
.side-menu-button-with-banner img {
  width: 2rem;
}

.side-bar-transition-enter-active,
.side-bar-transition-leave-active {
  transition: opacity 0.5s ease;
}

.side-bar-transition-enter-from,
.side-bar-transition-leave-to {
  opacity: 0;
}

.popup-helper {
  z-index: 999 !important;
  /* Comment the following line for debugging */
  opacity: 0;
  top: 0;
  left: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgb(19, 228, 0);
}

.section-title:hover {
  cursor: pointer;
}

.close-side-menu-icon:hover {
  cursor: pointer;
}

.arrow img {
  vertical-align: sub;
}

@media only screen and (max-width: 350px) {
  .sections {
    font-size: 1rem;
  }
  .side-bar {
    padding: 2rem 1rem 5rem 1.2rem;
  }
  .signin-button {
    font-size: 1.15rem;
    width: 7rem;
    height: 2rem;
  }
}
@media only screen and (max-width: 768px) {
  .side-menu-button {
    top: 1rem;
  }
  .side-menu-button-with-banner{
    top: 8rem;
  }
}
.side-bar-background {
  z-index: 998;
  /* Comment the following line for debugging */
  opacity: 0.5;
  top: 0;
  left: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  max-width: 500px;
  background: #000;
}
.side-bar-icons {
  align-items: center;
}
</style>

